import { Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { SMALL_TABLET_MIN_WIDTH } from 'constants/breakpoints';

import useMedia from 'hooks/useMedia';

import { selectControlBarExpanded } from '../../../selectors/videoPlayer';

import styles from './styles.module.less';

// WebVTT has several tags in it that we do not want to show on the
// screen. The main one is to differeniate voices, a feature we do not
// have.
const stripTags = caption => caption.replace(/<\/?[\s\d\w:\.]+>/g, '');

const Captions = ({ text, width }) => {
  const controlBarExpanded = useSelector(selectControlBarExpanded);
  const commentBuckets = useSelector(
    state => state.video_player.comment_buckets
  );
  const activeBucketIdx = useSelector(
    state => state.video_player.active_comment_bucket_index
  );
  const meetsMinWidthForComments = useMedia(
    [`(min-width: ${SMALL_TABLET_MIN_WIDTH}px)`],
    [true],
    false
  );

  if (!text) {
    return null;
  }

  const isShowingComment = activeBucketIdx in commentBuckets;

  let bottomHeightPx = 88;

  if (isShowingComment && controlBarExpanded && meetsMinWidthForComments) {
    bottomHeightPx += 64;
  }

  const fontSize = Math.max(12, Math.floor(width / 50));

  return (
    <div
      className={styles.captionContainer}
      style={{
        bottom: bottomHeightPx + 'px',
      }}
    >
      <div className={styles.captions}>
        <Text style={{ fontSize: `${fontSize}px` }}>{stripTags(text)}</Text>
      </div>
    </div>
  );
};

export default Captions;
